import { render, staticRenderFns } from "./FoxRadioButton.vue?vue&type=template&id=6ded2b87&scoped=true&"
import script from "./FoxRadioButton.vue?vue&type=script&lang=js&"
export * from "./FoxRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./FoxRadioButton.vue?vue&type=style&index=0&id=6ded2b87&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded2b87",
  null
  
)

export default component.exports